import { Form, Input, Select, App } from 'antd';
import { trpc } from '../../../lib/api';
import { withDevModalFilePath } from '../../../components/common';

const { Modal } = withDevModalFilePath('client/src/pages/admin/partners/InvitePartnerUserModal.tsx');

interface InvitePartnerUserModalProps {
  open: boolean;
  partnerCompanyId: string;
  onCancel: () => void;
  onSuccess: () => void;
}

export function InvitePartnerUserModal({ open, partnerCompanyId, onCancel, onSuccess }: InvitePartnerUserModalProps) {
  const { message } = App.useApp();
  const [form] = Form.useForm();

  const inviteMutation = trpc.partnerAdmin.inviteUser.useMutation({
    onSuccess: () => {
      message.success('招待メールを送信しました');
      form.resetFields();
      onSuccess();
    },
    onError: (error) => {
      message.error(error.message || '招待に失敗しました');
    },
  });

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      inviteMutation.mutate({
        partnerCompanyId,
        ...values,
      });
    });
  };

  return (
    <Modal
      title="パートナーユーザー招待"
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleSubmit}
      okText="招待"
      cancelText="キャンセル"
      confirmLoading={inviteMutation.isPending}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="email"
          label="メールアドレス"
          rules={[
            { required: true, message: 'メールアドレスを入力してください' },
            { type: 'email', message: '有効なメールアドレスを入力してください' },
          ]}
        >
          <Input placeholder="user@example.com" />
        </Form.Item>
        <Form.Item name="name" label="氏名（任意）">
          <Input placeholder="担当者名" />
        </Form.Item>
        <Form.Item name="role" label="ロール" initialValue="OrgMember">
          <Select
            options={[
              { label: '管理者', value: 'OrgAdmin' },
              { label: 'メンバー', value: 'OrgMember' },
            ]}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
